import React from "react";
import { Card, CardBody, CardHeader, Badge } from "reactstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const accessColor = {
  NONE: "danger",
  FULL: "success",
  READ: "warning",
  LIMITED: "secondary",
};

const PlanUsagePreview = ({ plan }) => {
  const { t, i18n } = useTranslation();

  const { country, modules, features } = useSelector((state) => ({
    country: state.Module.country,
    modules: state.SubscriptionPlanModule.modules,
    features: state.SubscriptionPlan.features,
  }));

  return (
    <Card className="mb-3">
      <CardHeader>{t('Plan Preview')}</CardHeader>
      <CardBody>
        <h5>{i18n.language === "en" ? plan.NameEn || t('New Plan') : plan.NameAr || t('New Plan')}</h5>
        <p className="text-muted mb-0">{i18n.language === "en" ? plan.DescriptionEn : plan.DescriptionAr}</p>
  
        <hr />
  
        <strong>{t('Modules')}</strong>
        <ul>
          {plan.Modules.map((m, i) => {
            const mod = modules.find((x) => x.ID == m.ModuleID);
            return (
              <li key={i}>
                {mod ? (i18n.language === "en" ? mod.NameEn : mod.NameAr) : "--"}
                <Badge color={accessColor[m.AccessLevel]} className="mx-2">
                  {t(m.AccessLevel)}
                </Badge>
              </li>
            );
          })}
        </ul>
  
        {plan.Limits.length > 0 && (
          <>
            <strong>{t('Usage Limits')}</strong>
            <ul>
              {plan.Limits.map((l, i) => {
                const limit = features.find((x) => x.ID == l.FeatureID);
                return (
                  <li key={i}>
                    {limit ? limit.Feature : "--"}: {l.LimitValue} / {l.LimitPeriod}
                  </li>
                );
              })}
            </ul>
          </>
        )}
  
        <hr />
        <strong>{t('Price')}</strong>
        <div>
          {`${plan.Price} ${country?.find((c) => c.ID == plan.CountryID)?.CurrencyCode || "KWD"}`} / {t(plan.BillingCycle)}
        </div>
      </CardBody>
    </Card>
  );
} 

export default React.memo(PlanUsagePreview);